import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<button id={{this.guid}} type=\"button\" class=\"tpk-button\" {{on \"click\" this.onClick}} ...attributes>\n    {{yield}}\n</button>", {
  moduleName: "@triptyk/ember-input/components/tpk-button.hbs"
});